module.exports = __webpack_public_path__ + "0e4ce7596ab86286d76bcfa5d91008d6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies/3.png
// module id = 3432
// module chunks = 0